export default __webpack_public_path__ + "static/bebas-neue-1bb5d46b1b7e3c363c60877813b47bc1.woff";